/* ---------------------------------------------------------------------------
 * MD Fashionwear — THE filler for the recommendation carousel
 *
 * WHY THIS LOADS BEFORE md-cart-recs.js
 * Both files used to fill the carousel and they raced for the same container via
 * the data-ready flag. When the old single-page path in md-cart-recs.js won on a
 * worldwide visit it found almost nothing usable — the block came out with 10
 * cards, and on another run with none at all.
 *
 * So this executes FIRST and claims the container synchronously, before
 * md-cart-recs.js has even been parsed. By the time its own fill runs it sees the
 * claim and stands down. One fill path, no race.
 *
 * The catalogue walk then happens asynchronously, and buildFrom is called once
 * md-cart-recs.js has loaded and defined it.
 *
 * WHY A WALK AND NOT ONE FETCH
 * /products.json pages 250 at a time; the store has 1,109 products of which only
 * 320 are worldwide-eligible (29%), and preorders cluster on certain pages. One
 * random page can yield almost nothing. md-cart-pool.js keeps going until it has
 * enough.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var NEED = 60;
  var SHOW = 24;

  function market() {
    var el = document.getElementById('cp-liquid-country');
    var c = (el && el.textContent.trim()) || (window.Shopify && window.Shopify.country) || '';
    return String(c).toUpperCase() === 'LB' ? 'LB' : 'WW';
  }

  // Wait for md-cart-recs.js to define the card builder.
  function whenBuilderReady(cb) {
    var tries = 0;
    (function attempt() {
      if (window.MDCartRecs && window.MDCartRecs.buildFrom) { cb(); return; }
      if (tries++ > 60) return;
      setTimeout(attempt, 100);
    })();
  }

  function fill() {
    var host = document.getElementById('md-recs');
    if (!host || host.getAttribute('data-ready') === '1') return;

    // A saved set means hydration owns this render.
    if (window.MDCartStore) {
      var saved = window.MDCartStore.load();
      if (saved && saved.shown && saved.shown.length) return;
    }

    if (!window.MDCartPool) return;

    // Claim synchronously, and keep the claim. Releasing it early is what let the
    // old path back in.
    host.setAttribute('data-ready', '1');

    var worldwide = market() !== 'LB';

    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = ((cart && cart.items) || []).map(function (i) { return String(i.product_id); });
        return window.MDCartPool.gather({
          worldwide: worldwide,
          inCart: inCart,
          excluded: {},
          need: NEED
        });
      })
      .then(function (products) {
        if (!products || !products.length) {
          host.removeAttribute('data-ready');
          return;
        }
        whenBuilderReady(function () {
          window.MDCartRecs.buildFrom(products.slice(0, SHOW), products.slice(SHOW), {});
        });
      })
      .catch(function () { host.removeAttribute('data-ready'); });
  }

  function boot() {
    fill();

    var tries = 0;
    (function attempt() {
      if (document.getElementById('md-recs')) { fill(); return; }
      if (tries++ > 40) return;
      setTimeout(attempt, 120);
    })();

    if (window.MutationObserver && document.body) {
      var queued = false;
      new MutationObserver(function () {
        var host = document.getElementById('md-recs');
        if (!host || host.getAttribute('data-ready') === '1') return;
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; fill(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDCartInit = { fill: fill };
})();
